import { DvSnackbarConfig } from '@devinco/ui/dds/snackbar';
import { environment } from '@env/environment';

export const SnackBarConfig: {
  Success: DvSnackbarConfig;
  Warning: DvSnackbarConfig;
  Error: DvSnackbarConfig;
} = {
  Success: {
    displayTime: environment.snackBarDisplayTime,
    vPos: 'top',
    type: 'success',
  },
  Error: {
    displayTime: 5000,
    vPos: 'top',
    type: 'danger',
  },
  Warning: {
    displayTime: environment.snackBarDisplayTime,
    vPos: 'top',
    type: 'warning',
  },
};
